import { Component, Inject, Input, OnInit } from '@angular/core';
import { FieldListItem } from '@assetaccountant/api/models/field-list-item';
import { ListFieldsResponse } from '@assetaccountant/api/models/fields/list-fields.response';
import {
  FieldAssignmentGroup,
  FieldValueAllocationGroup,
} from '@assetaccountant/assets/models/field-form-model';
import { sortFieldValues } from '@assetaccountant/core/models/field';
import { CompareFn, SORT_COMPARE } from '@assetaccountant/core/services/compare.factory';
import { TypedFormArray, TypedFormBuilder } from '@assetaccountant/core/utils/typed-forms';

@Component({
  selector: 'app-new-asset-fields-form',
  templateUrl: './new-asset-fields-form.component.html',
  styleUrls: ['./new-asset-fields-form.component.scss'],
  standalone: false,
})
export class NewAssetFieldsFormComponent implements OnInit {
  @Input() listFieldsResponse: ListFieldsResponse;
  @Input() fieldControls: TypedFormArray<FieldAssignmentGroup>;
  @Input() classificationDefaults?: { [key: string]: string };

  fields: FieldListItem[] = [];

  constructor(
    private fb: TypedFormBuilder,
    @Inject(SORT_COMPARE) private sortCompare: CompareFn,
  ) {}

  ngOnInit() {
    this.fields = this.listFieldsResponse.fields
      .filter(f => f.isEnabled)
      .map(f => sortFieldValues(f, this.sortCompare, { removeDisabled: true }));

    this.fieldControls.clear();
    for (const field of this.fields) {
      const valueId = this.classificationDefaults?.[field.id];
      this.fieldControls.push(
        this.fb.group({
          fieldId: field.id,
          valueIdAllocations: this.fb.array<FieldValueAllocationGroup>(
            valueId ? [this.fb.group({ valueId, allocation: 1 })] : [],
          ),
        }),
      );
    }
  }
}
